import React, { memo } from "react";
// 1. Import both Editor and DiffEditor
import { Editor, DiffEditor } from "@monaco-editor/react";
import { useMonacoStatus } from "../contexts/MonacoStatusContext.js";

// 2. Accept a 'diffEditor' prop and spread the rest of the props
const SafeEditor = ({ diffEditor, ...props }) => {
  const { monacoStatus } = useMonacoStatus();

  // The error handling remains the same and applies to both editors
  if (monacoStatus === "failed") {
    return (
      <div
        style={{
          padding: "20px",
          border: "1px dashed grey",
          color: "red",
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <strong>Error:</strong> The code editor failed to load. Please try
        refreshing the page.
      </div>
    );
  }

  // 3. Conditionally render the DiffEditor if the prop is true
  if (diffEditor) {
    return <DiffEditor {...props} />;
  }

  // By default, render the standard Editor
  return <Editor {...props} />;
};

// Wrap the component with React.memo before exporting
export default memo(SafeEditor);
